import { userManager } from '@/auth/AuthContext';
import { PATHS } from '@/constants';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Loading from '../Loading/Loading';

const LogoutCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    userManager.signoutRedirectCallback().finally(() => {
      navigate(PATHS.APPLICANT.DASHBOARD);
    });
    // eslint-disable-next-line
  }, []);

  return <Loading />;
};

export default LogoutCallback;
